// Copilot session addressing, in a leaf module on purpose.
//
// SideBar links to the blank-session path and TseDashboard5 renders SideBar, so
// exporting these from the dashboard would close an import cycle between the
// two. The values are strings with no dependencies of their own, so they live
// here and both sides import them.
//
//   /TseDashboard5/new   a blank session: nothing stored, nothing to share
//   /TseDashboard5/<id>  a real session (shared link, reload, Recents)
//   /TseDashboard5       an alias for /new (App.js redirects)
//
// A session does not exist server-side until its first turn commits, which is
// why the blank state gets a name of its own instead of a freshly minted uuid:
// an id in the address bar for a session nobody has heard of reads as a real,
// shareable chat that is somehow missing from Recents.
export const NEW_SESSION_SEGMENT = "new";
export const NEW_SESSION_PATH = `/TseDashboard5/${NEW_SESSION_SEGMENT}`;

// ── Enterprise user copilot ───────────────────────────────────────────────
//
//   /ent-user        the greeting screen — no session open yet
//   /ent-user/<id>   a saved enterprise chat, reopened from the rail
//
// Enterprise runs the same dashboard EMBEDDED inside ChatWindow, which is why
// it needs a base of its own: /TseDashboard5 is gated on AGENT_ROLES, so a
// `user` clicking a recents row on that path is bounced to "/" by App.js.
export const ENT_BASE_PATH = "/ent-user";
export const entSessionPath = (id) => `${ENT_BASE_PATH}/${encodeURIComponent(id)}`;
